<template>
  <div class="languageBarWrap">
    <div class="languageName">You are previewing this page in:</div>
    <div class="selectWrapper">
      <div class="imageWrapper">
        <img v-if="activeFlag" :src="activeFlag" />
      </div>
      <select
        v-if="languageTypes.length"
        class="langType"
        v-model="languageTypesIndex"
        @change="toggleLanguage"
      >
        <option
          class="langType__item"
          v-for="languageType of languageTypes"
          :key="languageType.index"
          :value="languageType.index"
        >
          <span>{{ languageType.foreignName }}</span>
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebase";
import newLanguageTypesFormatMixin from "@/mixins/newLanguageTypesFormatMixin";

export default {
  mixins: [newLanguageTypesFormatMixin],
  data() {
    return {
      languageTypesIndex: "",
      languageTypes: [],
      activeFlag: "",
    };
  },
  async created() {
    this.languageTypesIndex = await this._getLanguageIndex();
    this.languageTypes = await this._getCorrectEventLanguages();
    this.activeFlag = this.languageTypes[this.languageTypesIndex].countryFlag;
  },
  methods: {
    toggleLanguage() {
      //Change index
      db.ref(`users/${this.$userId}`).update({
        languageTypesIndex: this.languageTypesIndex,
      });

      //Change flag
      this.activeFlag = this.languageTypes[this.languageTypesIndex].countryFlag;
    },
  },
};
</script>

<style scoped>
.languageBarWrap {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  padding: 12px;
}

.languageName {
  align-items: center;
  font-size: 24px;
}

.langType__item {
  font-size: 16px;
}

select.langType {
  color: #707070;
  background-color: rgb(255, 255, 255);
  font-weight: bold;
  border: 1px solid #707070;
  border-radius: 8px;
  padding-left: 50px;
  width: 252px;
  height: 44px;
  margin-right: 20px;
  cursor: pointer;
}

.selectWrapper {
  margin-left: 16px;
  position: relative;
}

.imageWrapper {
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
  left: 8px;
}

.imageWrapper img {
  width: 40px;
  height: 28px;
}

.languageSettingsWrapper {
  display: flex;
  align-items: center;
}

select.languageSettingsSelect {
  background-color: #f7f7f7;
  padding-left: 52px;
  width: 200px;
}

.settingsLanguageTitle {
  color: #707070;
  font-size: 24px;
  margin-right: 16px;
}
</style>
